import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import '~/features/voice-search'

// skin
const skin = era.skin('widgets/Popups/VoiceSearchPopup/')

VoiceSearchPopup.displayName = 'VoiceSearchPopup'
export function VoiceSearchPopup(): JSX.Element | null {
  return <ui.RenderSkin from={skin} name='voiceSearchPopup' />
}
